import * as React from 'react';
import { connect } from 'react-redux';

// Components
import { ContentContainer } from '../../../../components/Layout/ContentContainer';
import { Screen } from '../../../../components/Layout/Screen';
import Title, { Highlight } from '../../../../components/Title';
import TextBlock from '../../../../components/TextBlock';

// Assets
import { brandColors } from '../../../../styles/variables';
import background from '../../../../assets/images/pages/neva/neva-pharmacist.png';

const StyledScreen = Screen.extend`
  position: relative;
  overflow: hidden;
  background: url(${background}) center no-repeat;
  background-size: cover;
  padding-top: 1px;
  margin-top: -1px;

  .title {
    padding: 156px 0 0;
  }
`;

const AccreditedScreen = () => (
  <StyledScreen>
    <ContentContainer>
      <Title primary={false} className="title" color={brandColors.white}>
        Beyond <Highlight>the</Highlight>
        <br />launch
      </Title>
      <br />
      <TextBlock width="382px" color={brandColors.white}>
        <p>
          The project evolved into a platform that is not only accessible to pharmacists but also
          available to specialist travel nurses and even GPs. The platform is still thriving and is
          in daily use by healthcare professionals seven years after its first launch.
        </p>
      </TextBlock>
    </ContentContainer>
  </StyledScreen>
);

export default connect()(AccreditedScreen);



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/MakingOfAnIndustryLeader/screens/Accredited.jsx